/**
 * Zadane SEO vrijednosti (usklađeno s public/index.html).
 * Pri promjeni ažuriraj i meta name="description", og:description u index.html.
 */
export const DEFAULT_SITE_META_DESCRIPTION =
  "Bezglutenski recepti za domaću kuhinju — slatko i slano, ideje za doručak, ručak i desert. Savjeti za celijakiju i gluten free prehranu; putovanja i preporuke restorana.";

/**
 * Usklađeno s public/index.html (meta name="keywords").
 */
export const DEFAULT_SITE_KEYWORDS =
  "bezglutenski recepti, gluten free, bez glutena, celijakija, bezglutenska prehrana, bezglutenska kuhinja, bezglutenski kolači, bezglutensko pecivo, slatko bez glutena, recepti bez glutena, bez glutena slastice, GF recepti, bezglutenski doručak, bezglutenski desert, blog recepti, kuhinja bez glutena, hrvatska, savjeti za celijakiju, putovanja bez glutena, bezglutenski način života, bez glutena za djecu, slano bez glutena, bez pšenice, zdrava prehrana";
